<template>
  <main v-if='kirby.page.intendedTemplate == "default"' v-scroll-lock='scrollLock'>
    <close/>
    <h1 v-html='kirby.page.strings.title' />
    <article>
      <!-- Sections -->
      <blocks :content='JSON.parse(kirby.page.strings.builder)' :page='kirby.page' />
    </article>
  </main>
</template>

<script>
import mixins from '.././mixins.js';
import Vue from 'vue';
import VScrollLock from 'v-scroll-lock'

Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
})

export default {
  mixins: [mixins], //kirby(), urltopath(), etc,
  data: function() {
    return {
      scrollLock: false,
    }
  },
  mounted: function(){
    this.$emit("addReasonToShowVeil");
  },
  destroyed: function(){
    this.$emit("removeReasonToShowVeil");
  },
  activated: function(){
    this.scrollLock = true;
  },
  deactivated: function(){
    this.scrollLock = false;
  }
}
</script>

<style scoped>

  h1 {
    margin-left: -0.05em;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }

</style>

<style>

article a {
  color: var(darkgray);
  text-decoration: underline;
}

</style>
